import { parseCalendarDate } from './calendar-date.js';
import { BUSINESS_TIME_ZONE } from './constants.js';
import { toInstant, toPlainDate } from './temporal.js';
/** Kind 4: the Pacific calendar date a real instant falls on (D24). */
export function businessDateOfTimestamp(instant) {
    const pacific = toInstant(instant).toZonedDateTimeISO(BUSINESS_TIME_ZONE);
    return parseCalendarDate(pacific.toPlainDate().toString());
}
export function todayBusinessDate(now = new Date()) {
    return businessDateOfTimestamp(now);
}
/** The instant Pacific midnight begins `ymd`. */
export function startOfBusinessDate(ymd) {
    return new Date(toPlainDate(ymd).toZonedDateTime(BUSINESS_TIME_ZONE).epochMilliseconds);
}
/**
 * The instant's Pacific wall clock re-read as UTC: what a writer that stores a `Date` by its UTC
 * fields (an XLSX cell) needs so the sheet shows the Pacific time the screen shows.
 */
export function businessWallClockAsUtc(instant) {
    const wall = toInstant(instant).toZonedDateTimeISO(BUSINESS_TIME_ZONE).toPlainDateTime();
    return new Date(wall.toZonedDateTime('UTC').epochMilliseconds);
}
//# sourceMappingURL=business-day.js.map